import React from "react";
import { ContentLoader, Breadcrumb } from "../../../components/Common";
import { useCompanySettings } from "./hooks/useCompanySettings";
import CompanyForm from "./components/CompanyForm";

const CompanySettingsPage = () => {
    document.title = "Dados da Empresa | NeoApp - Sistema de Gestão";
    
    const { data, loading, saving, actions } = useCompanySettings();

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Dados da Empresa" />
            </div>

            <div className="border-top mb-3"></div>

            {loading ? (
                <ContentLoader message="Carregando Empresa" />
            ) : (
                <CompanyForm 
                    initialData={data} 
                    onSave={actions.handleSubmit} 
                    isSaving={saving} 
                />
            )}
        </React.Fragment>
    );
};

export default CompanySettingsPage;
